import React, { useState } from 'react';
import experienceData from './data/experience_data.js';

export default function Experience() {
  const [selectedCategory, setSelectedCategory] = useState(null);

  // Function to handle category filter
  const handleFilter = (category) => {
    setSelectedCategory(category);
  };

  // Filter projects based on selected category
  const filteredProjects = selectedCategory
    ? experienceData.filter(experience => experience.category === selectedCategory)
    : experienceData;

  return (
    <section className="content" id='Experience'>
      <h2>Work Experiences</h2>
      <div className="filter">
        <a href="#Experience" onClick={() => handleFilter(null)}>All</a>
        <a href="#Experience" onClick={() => handleFilter("Full-Time")}>Full-Time</a>
        <a href="#Experience" onClick={() => handleFilter("Internship")}>Internship</a>
        <a href="#Experience" onClick={() => handleFilter("Part-Time")}>Part-Time</a>
      </div>
      
      <div className='project'>
        {filteredProjects.map(experience => (
          <div key={experience.id}>
            <div className='project-title'>
              <h3>{experience.role}</h3>
              <p>{experience.date}</p>
            </div>
            <p className='lead'>{experience.category} | {experience.organization}</p>
            <p>Work Done:</p>
            {experience.content.split('*').map((item, index) => (
                <p key={index}>{item.trim()}</p> 
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
